import { Meeting } from "../api/models/Meeting";
import { useMemo } from "react";
import _ from "lodash";

export enum GadderPrice {
  ONE = "10",
  TWO = "30",
  THREE = "60",
}

const priceToDisplayString: Record<string, string> = {
  [GadderPrice.ONE]: "£",
  [GadderPrice.TWO]: "££",
  [GadderPrice.THREE]: "£££",
};
export const getMeetingPrice = (meeting?: Meeting): string | null => {
  if (!meeting?.price) {
    return null;
  }

  const description = priceToDisplayString[meeting.price];

  if (description) {
    return description;
  }

  try {
    const price: GadderPrice[] = JSON.parse(meeting.price);

    if (price.length === 0) {
      return null;
    }

    if (price.length === 1) {
      return priceToDisplayString[price[0]];
    }

    const sortedArray =
      price.length > 1
        ? price.sort((a, b) => parseInt(a) - parseInt(b))
        : price;

    return (
      priceToDisplayString[sortedArray[0]] +
      " - " +
      priceToDisplayString[sortedArray[sortedArray.length - 1]]
    );
  } catch (e) {
    return null;
  }
};

export const getMeetingTypes = (meeting?: Meeting): string[] => {
  if (!meeting?.category) {
    return [];
  }

  const description = typeToDisplayString[meeting.category];
  if (description) {
    return [description];
  }

  try {
    const category = JSON.parse(meeting.category);
    // @ts-ignore let it throw if there's no meeting date
    const date = new Date(meeting.date);
    return typeHandlerRequest(category, date);
  } catch (e) {
    return [meeting.category];
  }
};

export const getMeetingPicture = (meeting: Meeting) => {
  const placeImage =
    _.isNumber(meeting.generated_index) &&
    meeting.places?.[meeting.generated_index].picture_1;

  const uri = placeImage || meeting.district_image;

  return uri ? { uri } : require("../common/images/event.png");
};

export enum GadderMealType {
  COFFEE = "Coffee",
  DRINKS = "Drinks",
  MEAL = "Food",
}

const typeToDisplayString: Record<string, string> = {
  [GadderMealType.COFFEE]: "Coffee",
  [GadderMealType.MEAL]: "Meal",
  [GadderMealType.DRINKS]: "Drinks",
};

export const typeHandlerRequest = (type: GadderMealType[], date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return type.map((_type) => {
    return _type === GadderMealType.MEAL
      ? (hours > 4 && hours < 11) || (hours === 11 && minutes <= 30)
        ? "Breakfast"
        : (hours > 11 && hours <= 17) || (hours === 11 && minutes > 30)
        ? "Lunch"
        : "Dinner"
      : typeToDisplayString[_type] || _type;
  });
};

export const usePriceAndMenuOptions = (meeting?: Meeting) =>
  useMemo(
    () =>
      meeting
        ? [getMeetingPrice(meeting), ...getMeetingTypes(meeting)].filter(
            Boolean
          )
        : [],
    [meeting]
  );
